var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-tabs", {
    attrs: { tabs: _vm.tabs },
    on: { changed: _vm.changed },
    scopedSlots: _vm._u([
      {
        key: "infos",
        fn: function () {
          return [
            _vm.showLoading
              ? _c(
                  "section",
                  { staticClass: "eu-pa_6 eu-align_center" },
                  [_c("emd-loader", { attrs: { type: "_invert" } })],
                  1
                )
              : _c("payment-links-info"),
          ]
        },
        proxy: true,
      },
      {
        key: "orders",
        fn: function () {
          return [_c("orders-table")]
        },
        proxy: true,
      },
      {
        key: "subscriptions",
        fn: function () {
          return [_c("subscriptions-table")]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }